// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contAnalisisModal{
    position: relative;
    width: 100%;
    height: 100%;
    display: block;
}
.contAnalisisload{
    width:100%;
    height:100%;
    display:flex;
    justify-content:center;
    align-items:center
}
.bodyContAnalisisModal  .contAnalisisload  .loadSimple circle{
    stroke: hsl(215.3, 36.2%, 90.8%);
}

.headContAnalisisModal
{
    position: relative;
    width: 100%;
    height: 8%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--white-color);
    font-size: var(--font-size-small);
    color: var(--main-color);
    font-weight: bolder;
    z-index:1;
}
.bodyContAnalisisModal{
    position: relative;
  width: 100%;
  height: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
  padding-top: 10px;
  /* padding-bottom: 10px */
}
.bodyContAnalisisModal .loadSimple circle{
    stroke: hsl(0, 0%, 74%) !important;
}

.contTableAnalisis{
    position: relative;
    justify-content: center;
    align-items: center;
    width: 99%;
    height: 99%;
    display: block;
    /* background-color: aliceblue; */
}
.contInfoHostAnalisis{
    position: relative;
    display: block;
    justify-content: center;
    align-items: center;
    height: 20%;
    width: 100%;
    overflow-y: auto;
}
.contBodyTableAnalisis{
    position: relative;
    display: block;
    justify-content: center;
    align-items: center;
    height: 70%;
    width: 94%;
    left: 3%;
    overflow-y: auto;
}
.contHeadTableAnalisis{
position: relative;
display: flex;
justify-content: center;
align-items: center;
height: 5%;
width: 94%;
left: 3%;
background-color: var(--third-color);
}
.contCellHeadTableAnalisis{
    justify-content: center;
    display: flex;
    align-items: center;
    height: 100%;
    /* background: aliceblue; */
    width: 25%;
    color: var(--white-color);
    font-size: var(--font-size-xSmall);
    border: 1px solid rgba(240, 248, 255, 0.685);
    border-bottom: unset;
    border-top: unset;
}
.contRowTableAnalisis{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 25px;
    /* background-color: rgba(240, 248, 255, 0.233); */
    border-bottom: rgba(160, 160, 160, 0.342) 1px solid;
    color: var(--txt-color);
    font-size: var(--font-size-small);
}
.controwCellTableanalisis{
    justify-content: center;
    display: flex;
    align-items: center;
    height: 100%;
    font-size: var(--font-size-small);
    text-align: center;
    /* background: aliceblue; */
    /* width: 25%; */
    /* color: aliceblue; */
    /* border: 1px solid rgba(178, 178, 179, 0.459); */
    border-top: unset;
}

.contRowTableAnalisis:nth-child(odd){
    background-color: rgba(240, 248, 255, 0.144);
  }
  .contRowTableAnalisis:nth-child(even){
    background-color: rgba(122, 122, 122, 0.062);
  }
  .allResetDevices{
    width: 100%;
    height: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .txtAllResetDevices{
    width: 40%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--txt-color);
    font-size: var(--font-size-small);
  }`, "",{"version":3,"sources":["webpack://./src/components/modals-monitoreo/styles/AnalisisModal.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;AACA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB;AACJ;AACA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,iCAAiC;IACjC,wBAAwB;IACxB,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,kBAAkB;EACpB,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;IACI,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,cAAc;IACd,iCAAiC;AACrC;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,QAAQ;IACR,gBAAgB;AACpB;AACA;AACA,kBAAkB;AAClB,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,UAAU;AACV,UAAU;AACV,QAAQ;AACR,oCAAoC;AACpC;AACA;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,2BAA2B;IAC3B,UAAU;IACV,yBAAyB;IACzB,kCAAkC;IAClC,4CAA4C;IAC5C,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kDAAkD;IAClD,mDAAmD;IACnD,uBAAuB;IACvB,iCAAiC;AACrC;AACA;IACI,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iCAAiC;IACjC,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;IAChB,sBAAsB;IACtB,kDAAkD;IAClD,iBAAiB;AACrB;;AAEA;IACI,4CAA4C;EAC9C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;EACnC","sourcesContent":[".contAnalisisModal{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n}\r\n.contAnalisisload{\r\n    width:100%;\r\n    height:100%;\r\n    display:flex;\r\n    justify-content:center;\r\n    align-items:center\r\n}\r\n.bodyContAnalisisModal  .contAnalisisload  .loadSimple circle{\r\n    stroke: hsl(215.3, 36.2%, 90.8%);\r\n}\r\n\r\n.headContAnalisisModal\r\n{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 8%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: var(--white-color);\r\n    font-size: var(--font-size-small);\r\n    color: var(--main-color);\r\n    font-weight: bolder;\r\n    z-index:1;\r\n}\r\n.bodyContAnalisisModal{\r\n    position: relative;\r\n  width: 100%;\r\n  height: 90%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  overflow: auto;\r\n  padding-top: 10px;\r\n  /* padding-bottom: 10px */\r\n}\r\n.bodyContAnalisisModal .loadSimple circle{\r\n    stroke: hsl(0, 0%, 74%) !important;\r\n}\r\n\r\n.contTableAnalisis{\r\n    position: relative;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 99%;\r\n    height: 99%;\r\n    display: block;\r\n    /* background-color: aliceblue; */\r\n}\r\n.contInfoHostAnalisis{\r\n    position: relative;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 20%;\r\n    width: 100%;\r\n    overflow-y: auto;\r\n}\r\n.contBodyTableAnalisis{\r\n    position: relative;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 70%;\r\n    width: 94%;\r\n    left: 3%;\r\n    overflow-y: auto;\r\n}\r\n.contHeadTableAnalisis{\r\nposition: relative;\r\ndisplay: flex;\r\njustify-content: center;\r\nalign-items: center;\r\nheight: 5%;\r\nwidth: 94%;\r\nleft: 3%;\r\nbackground-color: var(--third-color);\r\n}\r\n.contCellHeadTableAnalisis{\r\n    justify-content: center;\r\n    display: flex;\r\n    align-items: center;\r\n    height: 100%;\r\n    /* background: aliceblue; */\r\n    width: 25%;\r\n    color: var(--white-color);\r\n    font-size: var(--font-size-xSmall);\r\n    border: 1px solid rgba(240, 248, 255, 0.685);\r\n    border-bottom: unset;\r\n    border-top: unset;\r\n}\r\n.contRowTableAnalisis{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 25px;\r\n    /* background-color: rgba(240, 248, 255, 0.233); */\r\n    border-bottom: rgba(160, 160, 160, 0.342) 1px solid;\r\n    color: var(--txt-color);\r\n    font-size: var(--font-size-small);\r\n}\r\n.controwCellTableanalisis{\r\n    justify-content: center;\r\n    display: flex;\r\n    align-items: center;\r\n    height: 100%;\r\n    font-size: var(--font-size-small);\r\n    text-align: center;\r\n    /* background: aliceblue; */\r\n    /* width: 25%; */\r\n    /* color: aliceblue; */\r\n    /* border: 1px solid rgba(178, 178, 179, 0.459); */\r\n    border-top: unset;\r\n}\r\n\r\n.contRowTableAnalisis:nth-child(odd){\r\n    background-color: rgba(240, 248, 255, 0.144);\r\n  }\r\n  .contRowTableAnalisis:nth-child(even){\r\n    background-color: rgba(122, 122, 122, 0.062);\r\n  }\r\n  .allResetDevices{\r\n    width: 100%;\r\n    height: 10%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .txtAllResetDevices{\r\n    width: 40%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: var(--txt-color);\r\n    font-size: var(--font-size-small);\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
